/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface MeteredItem
 */
export interface MeteredItem {
    /**
     *
     * @type {string}
     * @memberof MeteredItem
     */
    value: string;
    /**
     *
     * @type {string}
     * @memberof MeteredItem
     */
    label: string;
}

/**
 * Check if a given object implements the MeteredItem interface.
 */
export function instanceOfMeteredItem(value: object): value is MeteredItem {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function MeteredItemFromJSON(json: any): MeteredItem {
    return MeteredItemFromJSONTyped(json, false);
}

export function MeteredItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeteredItem {
    if (json == null) {
        return json;
    }
    return {

        'value': json['value'],
        'label': json['label'],
    };
}

  export function MeteredItemToJSON(json: any): MeteredItem {
      return MeteredItemToJSONTyped(json, false);
  }

  export function MeteredItemToJSONTyped(value?: MeteredItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'value': value['value'],
        'label': value['label'],
    };
}
